export const costs = [
  'You learn underground mining from scattered manuals, random videos and notes that never show how the whole mine fits together',
  "You don't fully understand mining methods, ground support, the drill-and-blast cycle or how ventilation really works, so every shift, inspection and decision underground feels stressful",
  'Mine layout, stoping methods, geomechanics, ventilation and haulage are never explained in one clear place',
  'You lack the time to build a complete, coherent understanding of underground operations from the portal to the stope',
];
